import templateUrl from './client_search.html.slim';
import controller from './client_search_controller';

angular.module('wbComponents').directive('wbClientSearch', [function ctor() {
  return {
    scope: true,
    restrict: 'E',
    controller,
    templateUrl,
    replace: true,
    link: ($scope, $el, $attrs) => {
      $scope.onSelect = (item, model, label) => {
        $scope.$parent.$eval(`${$attrs.onSelect}(item, model, label)`, {
          item,
          model,
          label,
        });
        $scope.selectedUser = null;
      };
      $scope.placeholder = $attrs.placeholder || 'Search for client';
    },
  };
},
]);
